module.exports = __webpack_public_path__ + "static/lloyds-83398dafb3c303eed389cd4e26ef2188.png";